module.exports = __webpack_public_path__ + "static/media/In_Transit.f6ffd517.svg";